import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MapPin, ArrowRight } from "@phosphor-icons/react";

// v405.11 — region hosting blocks: distributors tagged with a `region`
// (Svitlana Bilobrova = Ontario) get their live holdings shown as an
// at-a-glance block so east-coast stock is visible from the dashboard.
export const RegionBlocks = ({ regions }) => {
  const { t } = useTranslation();
  if (!regions || regions.length === 0) return null;
  return (
    <div className="grid gap-4 sm:grid-cols-2" data-testid="region-blocks">
      {regions.map((r) => (
        <section
          key={r.region}
          className="bg-zinc-900 text-white border-2 border-[#c9a24a] rounded-xl p-5 shadow-sm"
          data-testid={`region-block-${r.region}`}
        >
          <div className="flex items-start justify-between gap-3">
            <div>
              <p className="inline-flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-widest text-[#c9a24a]">
                <MapPin size={14} weight="fill" /> {r.region}
              </p>
              <p className="text-sm text-zinc-300 mt-0.5">
                {t("dashboard.region_hosted_by", { name: r.hosts.map((h) => h.name).join(", ") })}
              </p>
            </div>
            <div className="text-right shrink-0">
              <p className="text-3xl font-semibold tabular-nums leading-none" data-testid={`region-units-${r.region}`}>
                {r.total_units}
              </p>
              <p className="text-[11px] text-zinc-400 mt-1">
                {t("dashboard.region_units", { n: r.product_count })}
              </p>
            </div>
          </div>
          {r.products.length > 0 ? (
            <div className="flex flex-wrap gap-1.5 mt-3">
              {r.products.slice(0, 12).map((p, i) => (
                <span
                  key={`${p.name}-${i}`}
                  className="px-2 py-0.5 rounded-full bg-white/10 border border-white/20 text-xs font-medium tabular-nums"
                >
                  {p.name} × {p.qty}
                </span>
              ))}
              {r.products.length > 12 && (
                <span className="px-2 py-0.5 text-xs text-zinc-400">
                  +{r.products.length - 12}
                </span>
              )}
            </div>
          ) : (
            <p className="text-sm text-zinc-400 mt-3">{t("dashboard.region_empty")}</p>
          )}
          {r.hosts.length === 1 && (
            <Link
              to={`/distributors/${r.hosts[0].id}`}
              className="inline-flex items-center gap-1 text-xs font-semibold text-[#c9a24a] mt-3 hover:underline"
              data-testid={`region-view-${r.region}`}
            >
              {t("dashboard.region_view")} <ArrowRight size={12} weight="bold" />
            </Link>
          )}
        </section>
      ))}
    </div>
  );
};
